<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$l('INDEX.pane_label_production_order_base_info') || '基本信息'"
        name="base"
      >
        <BaseInfo ref="baseInfo" :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="
          $l('INDEX.pane_label_production_order_goods_info') || '产品信息'
        "
        name="orderGoods"
        lazy
      >
        <OrderGoods :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="
          $l('INDEX.pane_label_production_order_demand_fabric') || '产品面料'
        "
        name="demandFabric"
        lazy
      >
        <DemandFabric :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.pane_label_production_order_tech_doc') || '工艺说明'"
        name="techDoc"
        lazy
      >
        <TechDoc :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="
          $l('INDEX.pane_label_production_order_demand_material') || '产品辅料'
        "
        name="demandMabric"
        lazy
      >
        <DemandMaterial :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="
          $l('INDEX.pane_label_production_order_goods_package') || '产品包装'
        "
        name="goodsPackage"
        lazy
      >
        <GoodsPackage :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="
          $l('INDEX.pane_label_production_order_demand_package') || '外包装箱'
        "
        name="demandPackage"
        lazy
      >
        <DemandPackage :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="
          $l('INDEX.pane_label_production_order_demand_packing') || '装箱方案'
        "
        name="demandPacking"
        lazy
      >
        <DemandPacking :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.pane_label_production_order_proofing') || '样品需求'"
        name="orderProofing"
        lazy
      >
        <OrderProofing :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.pane_label_production_order_batch') || '交货批次'"
        name="orderBatch"
        lazy
      >
        <OrderBatch :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="
          $l('INDEX.pane_label_production_order_inspection') || '验货要求'
        "
        name="orderInspection"
        lazy
      >
        <OrderInspection :orderCode="orderCode" />
      </el-tab-pane>
      <el-tab-pane
        :label="
          $l('INDEX.pane_label_production_order_execution_log') || '执行日志'
        "
        name="orderExecutionLog"
        lazy
      >
        <OrderExecutionLog :orderCode="orderCode" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import BaseInfo from './base-info'
import OrderGoods from './order-goods'
import DemandFabric from './demand-fabric'
import TechDoc from './tech-doc'
import DemandMaterial from './demand-material'
import GoodsPackage from './goods-package'
import DemandPackage from './demand-package'
import DemandPacking from './demand-packing'
import OrderProofing from './order-proofing'
import OrderBatch from './order-batch'
import OrderInspection from './order-inspection'
import OrderExecutionLog from './order-execution-log'

export default {
  props: {
    orderCode: { type: String, default: '' },
  },
  components: {
    BaseInfo,
    OrderGoods,
    DemandFabric,
    TechDoc,
    DemandMaterial,
    GoodsPackage,
    DemandPackage,
    DemandPacking,
    OrderProofing,
    OrderBatch,
    OrderInspection,
    OrderExecutionLog,
  },
  data() {
    return { activeName: 'base' }
  },
}
</script>
